import fr from 'facet-rest';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { dataAttrs } from 'Helpers/Testing';
import React from 'react';
import { useBuildCommonFQEventProperties } from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';

export const ScheduleMeetingButton = ({ resource, isModal }) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  return resource.withRelationship(fr.relationships.scheduleChiliPiperMeeting.name, (rel) => (
    <FDPrimaryActionButton
      icon={rel.meta('icon')}
      label={rel.meta('prompt')}
      href={rel.link('related').url()}
      onClick={() => {
        logStandardizedEvent(categories.facetQuiz, eventTypes.completed, eventSubTypes.clickedCTA, {
          eventProperties: {
            ...buildCommonFQEventProperties(resource),
            action: 'schedule call',
            isModal,
          },
        });
      }}
      {...dataAttrs(`schedule-chilipiper-meeting${isModal ? '-modal' : ''}`)}
    />
  ), () => null);
};
